import { Sun, Moon, Monitor, Check } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const OPTIONS = [
  { v: "light", label: "Light", Icon: Sun },
  { v: "dark", label: "Dark", Icon: Moon },
  { v: "system", label: "Match my device", Icon: Monitor },
];

export const ThemeToggle = () => {
  const { mode, resolved, setMode } = useTheme();
  const Current = resolved === "dark" ? Moon : Sun;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button type="button" aria-label="Change colour mode" data-testid="theme-toggle-button"
          className="p-2 border border-white/40 transition-colors duration-200 hover:bg-white/10">
          <Current size={16} className="transition-transform duration-300" key={resolved} />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="rounded-none min-w-[200px]">
        {OPTIONS.map(({ v, label, Icon }) => (
          <DropdownMenuItem key={v} onClick={() => setMode(v)} data-testid={`theme-option-${v}`}
            className="rounded-none gap-3 cursor-pointer">
            <Icon size={15} />
            <span className="flex-1">{label}</span>
            {mode === v && <Check size={14} />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
